export default __webpack_public_path__ + "static/media/share.c6dab44d.svg";